export enum PageStatus {
  MAIN = 'MAIN',
  EDIT = 'EDIT',
  ADD = 'ADD',
}
